export default __webpack_public_path__ + "static/media/menu.524e4d4d.svg";